import React, { useEffect, useRef, useState } from "react";
import { Formik, Form } from "formik";
import { documentsValidationSchema } from "../../utils/ValidationSchema";
import { DocumentsFormType } from "../../utils/formType";
import { DocumentsInitialFormValues } from "../../utils/initialFormValues";
import DocumentsComponent from "./component/DocumentsComponent";
import FooterButton from "uicomponents/FooterButton";
import {
  BACK_BUTTON_TEXT,
  NEXT_BUTTON_TEXT,
  LOADING_BUTTON_TEXT,
} from "pages/WorkersCompApplcation/utils/contants";
import { DocumentType } from "types";
import { useUpdateNoLossRunsReportReasonMutation } from "types/generated/operations";
import { getProspectUuid } from "utils/idHelpers";
import Alert from "uicomponents/Alert";
import {
  trackFormError,
  trackPageViewUserStep,
} from "utils/analytics/trackEvent";
import { errorMessageMap } from "utils/helper";

interface IDocumentsProps {
  setNextStep: () => void;
  setPreviousStep: () => void;
  data: DocumentType;
}

const Documents = ({ ...props }: IDocumentsProps): JSX.Element => {
  useEffect(() => {
    window.scrollTo(0, 0);
    trackPageViewUserStep(8, "documents");
  }, []);
  const { setNextStep, setPreviousStep, data } = props;
  const [errorMessage, setErrorMessage] = useState("");
  const [isLoadingSteps, setIsLoadingSteps] = useState(false);

  const initialFormValues: DocumentsFormType = DocumentsInitialFormValues(data);

  const [
    updateNoLossRunsReportReason,
    { loading: updateNoLossRunsReportReasonLoading },
  ] = useUpdateNoLossRunsReportReasonMutation();

  const [isError, setIsError] = useState(false);

  const handleOnSubmit = async (values: DocumentsFormType) => {
    setIsLoadingSteps(true);
    try {
      await updateNoLossRunsReportReason({
        variables: {
          prospectUuid: getProspectUuid(),
          noLossRunsReportOtherReason: values.noLossRunsReportOtherReason,
          noLossRunsReportReason: values.noLossRunsReportReason,
        },
      });
      setNextStep();
    } catch (error: any) {
      const errorMessage: string = error?.message;
      errorMessageMap[errorMessage] &&
        setErrorMessage(errorMessageMap[errorMessage]);
      trackFormError(error, errorMessage);
      setIsError(true);
      return;
    }
  };

  const handleBack = (): void => {
    setPreviousStep();
  };

  const fieldRefs = useRef<{ [key: string]: HTMLInputElement | null }>({});

  // Helper function that makes the browser scroll a specific field into view
  const focusField = (fieldName: string) => {
    if (fieldRefs.current[fieldName]) {
      fieldRefs.current[fieldName]?.scrollIntoView({
        behavior: "smooth",
        block: "center",
      });
    }
  };

  return (
    <>
      <Formik
        initialValues={initialFormValues}
        validationSchema={documentsValidationSchema}
        onSubmit={handleOnSubmit}
      >
        {({ errors, handleSubmit }) => (
          <Form
            onSubmit={(e) => {
              e.preventDefault();
              const firstErrorFieldName = Object.keys(errors)[0];
              focusField(firstErrorFieldName);
              handleSubmit(e);
            }}
          >
            <DocumentsComponent
              data={data?.applications?.[0]}
              fieldRefs={fieldRefs}
            />
            <FooterButton
              nextButtonText={
                updateNoLossRunsReportReasonLoading || isLoadingSteps
                  ? LOADING_BUTTON_TEXT
                  : NEXT_BUTTON_TEXT
              }
              backButtonText={BACK_BUTTON_TEXT}
              disabled={updateNoLossRunsReportReasonLoading || isLoadingSteps}
              handleBackClick={handleBack}
            />
            {isError && <Alert message={errorMessage} />}
          </Form>
        )}
      </Formik>
    </>
  );
};

export default Documents;
